import { type Writable, writable } from 'svelte/store';
import { type Player } from './src/types';


export const authenticated:Writable<boolean> = writable(false);

export const season:Writable<string> = writable();

export const team:Writable<string> = writable();

export const players:Writable<Player[]> = writable();

